/* eslint-disable no-nested-ternary */
import * as React from 'react';
import {
  Grid, TextField, Box,
} from '@material-ui/core';
import { Autocomplete, Skeleton } from '@material-ui/lab';
import type { IMarkingDynamicBehavior } from '../Utilities/PolicyConfiguratorInterfaces';
import type ILabelEnumPair from '../../../global/GlobalInterfaces';
import getDepartments from '../../../../lib/SWRfetchers/getDepartments';

interface IMarkingDynamicBehaviorProps {
  markingDynamicBehavior?: IMarkingDynamicBehavior | null;
  setMarkingDBFormValues?: (values: IMarkingDynamicBehavior) => void,
}

const MarkingDynamicBehaviorFilter: React.FC<IMarkingDynamicBehaviorProps> = ({
  markingDynamicBehavior,
  setMarkingDBFormValues,
}) => {
  const [showErrors, setShowErrors] = React.useState<boolean>(false);
  // const [currentDept, setCurrentDept] = React.useState<ILabelEnumPair>();
  const { departments } = getDepartments();

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    switch (event.target.id) {
      case 'title':
        setMarkingDBFormValues?.({ ...markingDynamicBehavior, title: event.target.value });
        break;
      case 'message':
        setMarkingDBFormValues?.({ ...markingDynamicBehavior, message: event.target.value });
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        {
          departments ? (
            <Grid item xs={4}>
              <Box pl={2}>
                <Autocomplete
                  value={markingDynamicBehavior?.department}
                  onChange={(e, selectedDepartment: ILabelEnumPair | null) => {
                    if (selectedDepartment) {
                      const tempFormValues: IMarkingDynamicBehavior = { ...markingDynamicBehavior, department: { label: selectedDepartment.label, value: 0 } };
                      setMarkingDBFormValues?.(tempFormValues);
                    } else {
                      const tempFormValues: IMarkingDynamicBehavior = { ...markingDynamicBehavior, department: null };
                      setMarkingDBFormValues?.(tempFormValues);
                      setShowErrors(true);
                    }
                  }}
                  autoHighlight
                  autoSelect
                  options={departments.sort((a, b) => a.label.localeCompare(b.label))}
                  getOptionLabel={(option) => option.label.toString()}
                  renderInput={(params) => (
                    <TextField
                      // eslint-disable-next-line react/jsx-props-no-spreading
                      {...params}
                      label="Department"
                      id="department-type-input"
                      variant="outlined"
                      helperText={showErrors && markingDynamicBehavior?.department === null ? 'Required' : ''}
                    />
                  )}
                />
              </Box>
            </Grid>
          ) : (<Skeleton height="56px" variant="rect" />)
        }
        <Grid item xs={10}>
          <Box pl={2}>
            <TextField
              inputProps={{ maxLength: 254 }}
              onChange={handleInputChange}
              value={markingDynamicBehavior?.title}
              id="title"
              fullWidth
              label="Title"
              variant="outlined"
              required
              error={showErrors && markingDynamicBehavior?.title === ''}
              helperText={showErrors && markingDynamicBehavior?.title === '' ? 'Required' : ''}
            />
          </Box>
        </Grid>
        <Grid item xs={10}>
          <Box pl={2}>
            <TextField
              multiline
              rows={3}
              onChange={handleInputChange}
              value={markingDynamicBehavior?.message}
              id="message"
              fullWidth
              label="Message"
              variant="outlined"
              required
              error={showErrors && markingDynamicBehavior?.message === ''}
              helperText={showErrors && markingDynamicBehavior?.message === '' ? 'Required' : ''}
            />
          </Box>
        </Grid>
      </Grid>

    </>
  );
};
export default MarkingDynamicBehaviorFilter;
